import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import PatientLogin from "./patient-app/PatientLogin";
import PatientLocalStorage from "./patient-app/PatientLocalStorage";
import PatientResult from "./patient-app/PatientResult";
import PatientLayout from "./patient-app/PatientLayout";
import PatientDownload from "./patient-app/PatientDownload";
import PatientProfileShare from "./patient-app/PatientProfileShare";

function PrivateRoute({ children, ...rest }) {

    return (
        <Route {...rest} render={() => {
            return PatientLocalStorage.isAuth()
                ? children
                : <Redirect to={'/app/login'} />
        }} />
    )
}

export default function PatientRouter() {
    return (
        <>
            <Router>
                <Switch>
                    <Route path={'/app/login'} component={PatientLogin} />
                    <Route path={'/app/download/study/:reportId/:name/:token'} component={PatientDownload} />
                    <Route path={'/ProfileShare'} component={PatientProfileShare} />
                    <PrivateRoute>
                        <PatientLayout>
                            <Switch>
                                <Route exact path={`/`} component={PatientResult} />
                            </Switch>
                        </PatientLayout>
                    </PrivateRoute>
                </Switch>
            </Router>
        </>
    )
}
